import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import { Asterisk, CountryPrefix, Inner, Label, Message, Outer, PhoneInputRow } from './input.styles';
import { CountrySelector } from 'react-international-phone';
import { PatternFormat } from 'react-number-format';
import 'react-international-phone/style.css';
const formatPattern = (format) => {
    if (!format)
        return '############';
    const formatString = typeof format === 'string' ? format : format.default;
    return formatString.replace(/\./g, '#').replace(/-/g, ' ').replace(/_/g, ' ');
};
export default function Mobile({ children, country, name, label, control, rules, shouldUnregister, type, isRequired, setCountry, updateMobile, ...inputProps }) {
    const { field, fieldState: { error }, } = useController({
        name,
        control,
        rules,
        shouldUnregister,
    });
    return (_jsxs(Outer, { children: [_jsxs(Inner, { type: type, children: [_jsxs(Label, { htmlFor: label, children: [children ?? label, isRequired && _jsx(Asterisk, { children: "*" })] }), _jsxs(PhoneInputRow, { children: [_jsx(CountrySelector, { selectedCountry: country?.iso2.toLowerCase() || 'us', onSelect: setCountry }), _jsxs(CountryPrefix, { children: ["+", country?.dialCode] }), _jsx(PatternFormat, { allowEmptyFormatting: true, className: classNames('pattern-format-input', { error: error }), format: formatPattern(country?.format), value: field.value, onValueChange: (values) => {
                                    updateMobile(values.value);
                                } }), _jsx("input", { type: "hidden", ...inputProps, name: name, ref: field.ref, defaultValue: field.value ?? undefined })] })] }), !!error && _jsx(Message, { children: error.message })] }));
}
